import styled, { css } from "styled-components";

export const TitleContainer = styled.div`
  margin: 16px 0;
`

export const TitleLabel = styled.span`
  color: var(--luft-primary);
  font-size: 16px;
  font-weight: 700;
`;

export const Container = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 32px;
  flex: 1;

  ${({ isMobile }) =>
    isMobile &&
    css`
      padding: 0 10%;
      margin-top: 0;
      margin-bottom: 16px;
    `}
`;
